import React, { useMemo } from 'react';
import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { withStyles, formattedCurrency } from 'vopay';
import { useLocation, useHistory } from 'react-router-dom';
import { Button, Complete } from 'UI';
import { getProductLabel } from '../FileUpload/utils/fileProcessingUtils';
import { FileUploadProduct, FileUploadService } from '../FileUpload/types';
import styles from './FileUploadConfirm.module.scss';

const { Box } = vp;
const classes = withStyles(styles);

const FileUploadConfirm: React.FC = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.Confirm' });
  const { t: tHeader } = useTranslation('translations', { keyPrefix: 'FileUpload.Review.Header' });
  const location = useLocation();
  const history = useHistory();

  // Get details from query params (same structure as FileUploadHeader)
  const queryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      product: params.get('product') as FileUploadProduct || '',
      service: params.get('service') as FileUploadService || '',
      fileName: params.get('fileName') || '',
      numberOfTransactions: parseInt(params.get('numberOfTransactions') || '0'),
      amount: parseFloat(params.get('amount') || '0'),
      currency: params.get('currency') || 'CAD',
    };
  }, [location.search]);

  const details = useMemo(
    () => [
      {
        label: tHeader('transferType'),
        value: queryParams.service,
      },
      {
        label: tHeader('paymentRail'),
        value: getProductLabel(queryParams.product),
      },
      {
        label: tHeader('currency'),
        value: queryParams.currency,
      },
      {
        label: tHeader('fileName'),
        value: queryParams.fileName,
      },
      {
        label: tHeader('numberOfTransactions'),
        value: queryParams.numberOfTransactions,
      },
      {
        label: tHeader('totalAmount'),
        value: `$${formattedCurrency(queryParams.amount.toString() || '')}`,
      },
    ],
    [queryParams],
  );

  const handleGoToHistory = () => {
    history.push('/file-upload-history');
  };

  const handleUploadNewFile = () => {
    history.push('/file-upload-history', { openDrawer: true });
  };

  return (
    <div className={classes('container')}>
      <div className={classes('completeWrapper')}>
        <Complete
          title={t('title')}
          amount={`$${queryParams.amount.toFixed(2)} ${queryParams.currency}`}
          username={queryParams.fileName}
          transactionType="sent"
          showAmounts={false}
          details={details}
        >
          <Box gap="md" width="100%" jc="sb" mt="sm">
            <Button color="secondary" onClick={handleGoToHistory} className={classes('button')} size="small">
              {t('goToHistory')}
            </Button>
            <Button onClick={handleUploadNewFile} className={classes('button')} size="small" colorScheme="primary">
              {t('uploadNewFile')}
            </Button>
          </Box>
        </Complete>
      </div>
    </div>
  );
};

export default FileUploadConfirm;
